import type { RouteObject } from "react-router";

import { DataEntryHomePage } from "./components/DataEntryHomePage";

export const dataEntryHomeRoutes: RouteObject[] = [
  { index: true, Component: DataEntryHomePage, handle: { roles: ["typist_csb", "typist_gsb"] } },
];
